import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Clipboard from 'clipboard';
import _ from 'lodash';
import { hideModal, showModal } from '../../../actions/ModalActions';
import '../../../stylesheets/pages/PublishWebsiteModal.less';

class PublishWebsiteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined
    };
  }

  componentDidMount() {
    this.initializeClipboard();
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#publish-website-share-modal-url-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      target.style.color = '#505050';
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
        target.style.color = '#01b4c0';
      }, 1500);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { wedding, isRegistryPublic, isRegistryVisible, closeModal } = this.props;
    const { isClipboardSupported } = this.state;

    return (
      <div id="publish-website-modalv2">
        <div className="modal-body text-center">
          <div className="containter-fluid">
            <div className="go-live-content">
              <img className="go-live-icon" src="/images/doodles/website_publish_confetti.svg" alt="confetti doodle" />
              <div className="go-live-header">
                <h3><strong>You&rsquo;re live!</strong> Guests can now view<br />your wedding website{isRegistryPublic && isRegistryVisible && ' and registry'}.</h3>
              </div>
              <div className="go-live-url">
                <div className="input">
                  <span className="url-text">
                    <span className="hidden-sm hidden-xs">{`${window.location.protocol}//`}</span>{`${window.location.host}/wedding/`}<strong>{wedding.slug}</strong>
                  </span>
                  <span>
                    {isClipboardSupported &&
                      <a to="">
                        <button id="publish-website-share-modal-url-copy" className="btn btn-link link copy-link" data-clipboard-text={`${window.location.protocol}//${window.location.host}/wedding/${wedding.slug}`}>
                            Copy<span className="hidden-sm hidden-xs"> Link</span>
                        </button>
                      </a>
                    }
                  </span>
                </div>
              </div>
              <div className="">
                <Link to={`/wedding/${wedding.slug}`} onClick={closeModal}>
                  <button className="btn btn-primary btn-wide btn-round go-live-button">View <span className="hidden-sm hidden-xs">Your</span> Website</button>
                </Link>
              </div>
              <div className="">
                <Link className="link hidden-xs" to="/wedding/manage" onClick={closeModal} >Go To Your Planning Dashboard ›</Link>
                <Link className="link visible-xs" to="/wedding/manage" onClick={closeModal}>Continue Wedding Planning ›</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PublishWebsiteModal.propTypes = {
  wedding: PropTypes.shape({}),
  isRegistryPublic: PropTypes.bool,
  isRegistryVisible: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  wedding: _.merge({}, state.publicWebsite.wedding, state.wedding.wedding),
  shareInfo: Object.assign({}, _.pick(state.wedding.account, 'enable_passcode', 'passcode')),
  isRegistryPublic: state.registry.is_public,
  isRegistryVisible: Object.values(state.website.pages.byId).some(val => val.type === 'REGISTRY' && val.hidden === false)
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(hideModal()),
  openWebsiteSettingsModal: () => dispatch(showModal('WEBSITE_SETTINGS', {}, { size: 'md' })),
  openCustomDomainModal: () => dispatch(showModal('CUSTOM_DOMAIN_MODAL'))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishWebsiteModal);



/** WEBPACK FOOTER **
 ** ./src/components/manage/website/PublishWebsiteModalv2.jsx
 **/